import { IDBPDatabase, openDB } from 'idb';
import { version } from 'os';
import React, { useState } from 'react';
class IndexedDb {
    private database: string;
    private db: any;

    constructor(database: string) {
        this.database = database;
    }

    public async createObjectStore(tableNames: string[]) {
        try {          
                this.db = await openDB(this.database, 500, {
                    upgrade(db: IDBPDatabase) {
                        for (const tableName of tableNames) {
                            if (db.objectStoreNames.contains(tableName)) {
                                continue;
                            }
                            db.createObjectStore(tableName, { autoIncrement:false, keyPath: 'Key' });                                          
                        }
                      
                    }
                   
                });             
                //     var request = indexedDB.open(this.database, 500);
                //     //Firefox code for db init
                //     request.onupgradeneeded = function (e:any) {
                //     myStorage.indexedDB.db = e.target.result;
                //     //var db = myStorage.indexedDB.db;
                //     // We can only create Object stores in a setVersion transaction;
                //     var db = e.target.result;
                //    for(const tableName of tableNames){
                //     if(db.objectStoreNames.contains(tableName)) {
                //         var storeReq = db.deleteObjectStore(tableName);
                //     }

                //     var store = db.createObjectStore(tableName,
                //         {keyPath: 'key'});
                //    }                
                //  }        
        }    
         catch (error) {
            return false;
        }
    }
    public  createObjectStores(tableNames: string) {
        try {  
            this.db =  openDB(this.database, 500, {
                upgrade(db: IDBPDatabase) {
                    db.createObjectStore(tableNames, { autoIncrement:false, keyPath: 'Key' });    
                }
               
            });
        }    
         catch (error) {
            return false;
        }
    }
    public async deleteObjectStores(tableNames: string[]) {
        try {
            this.db = await openDB(this.database, 500, {
                upgrade(db: IDBPDatabase) {
                    for (const tableName of tableNames) {
                        if (db.objectStoreNames.contains(tableName)) {
                            continue;
                        }
                        db.deleteObjectStore(tableName);
                    }
                },
            });
        } catch (error) {
            return false;
        }
    }
    public async getValue(tableName: string, id: string) {
        const tx = this.db.transaction(tableName, 'readwrite');
        const store = tx.objectStore(tableName);
        const result = await store.get(id);
       // console.log('Get Data ', JSON.stringify(result));     
         return result;
       
    }
    public async getValues(tableName: string, id: string) {    
            const tx = this.db.transaction(tableName, 'readwrite');
            const store = tx.objectStore(tableName);
            const result = await store.get(id);
            if(result!=null)
            {    
                return result.value.column;
            }
            else{
                return null;
            }            
    }
    public async getAllValue(tableName: string) {
        const tx = this.db.transaction(tableName, 'readonly');
        const store = tx.objectStore(tableName);
        const result = await store.getAll();
        //console.log('Get All Data', JSON.stringify(result));
        return result;
    }

    public async putValue(tableName: string, value: object,data:string) {
      //  this.db.createObjectStore(tableName, { autoIncrement:false, keyPath: 'Key' });
        const tx = this.db.transaction(tableName, 'readwrite');
        const store = tx.objectStore(tableName);
        const result = await store.put({Key:data,value});
        //console.log('Put Data ', JSON.stringify(result));
        return result;
    }

    public async putBulkValue(tableName: string, values: object[],data:string) {
        const tx = this.db.transaction(tableName, 'readwrite');
        const store = tx.objectStore(tableName);
        for (const value of values) {
            const result = await store.put({Key:data,value});
            // console.log('Put Bulk Data ', JSON.stringify(result));
        }
        //return this.getAllValue(tableName);
    }

    public async deleteValue(tableName: string, id: string) {
        const tx = this.db.transaction(tableName, 'readwrite');
        const store = tx.objectStore(tableName);
        const result = await store.get(id);
        if (!result) {
            return result;
        }
        await store.delete(id);
        return id;
    }
    public async Getpatname(db: string) {
        let pname:string="";
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let val = await indexedDb.getAllValue('Patientidentification');
        if(val!=null )
        {
            for(let i=0;i<val.length;i++)
            {
                if (val[i].Key == "CustGivenName")
                {
                 pname=pname+val[i].value.column;
                }
                if(val[i].Key == "CustSurName")
                {
                    pname=pname+val[i].value.column;
                }          
            }       
        }
        return pname     
    }
    public convertToBase64 = (file:any) => {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file);
          fileReader.onload = () => {
            resolve(fileReader.result);
          };
          fileReader.onerror = (error) => {
            reject(error);
          };
        });
      };
      public AddToOfflineImageProcessingQueue = async (db: string, tableName: string, keyName: string) => {
        const indexedDb = new IndexedDb("smacache");
        await indexedDb.createObjectStores("OfflineImagesQueue");
        await indexedDb.deleteValue('OfflineImagesQueue', db  + "-" + tableName  + "-" + keyName);
        await indexedDb.putValue('OfflineImagesQueue', {
            db: db, tableName: tableName,
            keyName: keyName
        }, db + "-" + tableName + "-" + keyName);

    }
    public patientcarerecord=[
        'background',
        'ActionIntervention',
        'MedicationAdminstered',
        'Observation',
        'Handover',
        'Attachement',
        'Patientidentification',
        'Caregivers',
        'Situation',
        'AssessmentPlan',
        'ProgressNotes',                  
    ]
}

export default IndexedDb;